import useBannerAd from "../../hooks/useBannerAd";

const AdBanner = () => {
    useBannerAd();

    return null; // No es necesario renderizar nada visualmente
};

export default AdBanner;
